import { ThemeEvents } from '@theme/events';

/** <stock-status> — re-renders itself from the server HTML the theme fetches on a variant change. */
class StockStatus extends HTMLElement {
  connectedCallback() {
    this.scope = this.closest('.shopify-section') || document;
    this.scope.addEventListener(ThemeEvents.variantUpdate, this.onVariantUpdate);
  }

  disconnectedCallback() {
    this.scope?.removeEventListener(ThemeEvents.variantUpdate, this.onVariantUpdate);
  }

  onVariantUpdate = (event) => {
    const doc = event.detail?.data?.html;
    if (!doc) return;
    const fresh = doc.querySelector(`stock-status[data-block-id="${this.dataset.blockId}"]`);
    if (fresh) this.innerHTML = fresh.innerHTML;
  };
}

if (!customElements.get('stock-status')) customElements.define('stock-status', StockStatus);
